import { render, staticRenderFns } from "./updateCustomer.vue?vue&type=template&id=00d1a888&scoped=true&"
import script from "./updateCustomer.vue?vue&type=script&lang=js&"
export * from "./updateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./updateCustomer.vue?vue&type=style&index=0&id=00d1a888&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1a888",
  null
  
)

export default component.exports